import { translate } from '@jsverse/transloco';
export enum EvidenceType {
    ATTACHMENT = 'ATTACHMENT',
    TEXT = 'TEXT',
}

export class EvidenceTypeHelper {
    static getEvidenceTypeLocale(evidenceType: EvidenceType): string {
        switch (evidenceType) {
            case EvidenceType.ATTACHMENT:
                return translate('CORE.EVIDENCE_TYPE.ATTACHMENT');
            case EvidenceType.TEXT:
                return translate('CORE.EVIDENCE_TYPE.TEXT');
            default:
                return '';
        }
    }
}
